(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    // When a product gallery slide is selected (via thumbnail, arrow, drag),
  // sync the corresponding variant in the product variant picker.
  document.addEventListener('slideshow:select', (event) => {
    // Only respond to user-initiated slide selections (thumbnail clicks, arrows, drags)
    if (!event.detail || !event.detail.userInitiated) return;

    const slide = event.detail.slide;
    if (!slide) return;

    const variantId = slide.getAttribute('data-variant-id');
    if (!variantId) return;

    const productInfo = slide.closest('.product-information');
    if (!productInfo) return;

    const variantPicker = productInfo.querySelector('variant-picker');
    if (!variantPicker) return;

    // Try exact match first (works for single-option products or when IDs align)
    const exactInput = variantPicker.querySelector(`input[data-variant-id="${variantId}"]`);
    if (exactInput && !exactInput.checked && !exactInput.disabled) {
      exactInput.click();
      return;
    }

    // For multi-option products (e.g. Color + Size), the variant ID on the slide
    // may differ from the variant ID on the color input because Shopify assigns
    // different variants depending on the currently selected combination.
    // Use the embedded variant map to find which option values belong to this variant,
    // then select the matching inputs in each fieldset.
    const variantMapEl = productInfo.querySelector('script[data-variant-option-map]');
    if (!variantMapEl) return;

    try {
      const variantMap = JSON.parse(variantMapEl.textContent);
      const optionValueIds = variantMap[variantId];
      if (!optionValueIds || !optionValueIds.length) return;

      // Find and click the first unchecked input whose option-value-id matches
      // one of this variant's option values (typically the Color option)
      for (const optionValueId of optionValueIds) {
        const input = variantPicker.querySelector(
          `input[data-option-value-id="${optionValueId}"]`
        );
        if (input && !input.checked && !input.disabled) {
          input.click();
          return;
        }
      }
    } catch (e) {
      // JSON parse error - silently ignore
    }
  });
  } catch(e) { console.error(e); }
})();

})();
